import { Link } from 'shared/types';
import createTemplate from '../template/createTemplate';

export default (link: Link, zone: string) =>
  createTemplate(link.href)({ zone });
